<template>
  <responsive-modal v-model="visible" title="Integrar Bling">
    <div class="tool-modal-bling">
      <a href="https://bling.com.br/" target="_blank" class="integration-link">
        Conheça o Bling
        <i class="ph ph-arrow-square-out" />
      </a>
      <div class="d-flex p-3 rounded-16 bg-3 gap-2">
        <i class="ph ph-warning-circle mt-1" />
        <div class="d-flex flex-column fs-14">
          Para integrar com o Bling, é necessário copiar a url de
          redirecionamento e colar em <br />
          <strong>Preferências > Cadastros > Cadastros de aplicativos</strong>
          e preencher os campos obrigatórios e escolher o escopos relacionados a
          notas fiscais.
          <br />
          Após cadastrar o aplicativo ZeusPay, serão fornecidos o Client ID e
          Client Secret para serem preenchidos aqui.
          <br />
          <strong
            >Após salvar a integração, você será redirecionado para permitir que
            o ZeusPay se integre com o Bling.</strong
          >
        </div>
      </div>
      <snow-input
        label="URL de redirecionamento"
        id="callback-url"
        :value="callback_url.url"
        readonly
      >
        <snow-button
          size="sm"
          variant="borderless"
          icon="ph ph-copy"
          @click="copyUrl(callback_url)"
        />
      </snow-input>
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <snow-select
          id="product-select"
          required
          v-model="form.product_id"
          label="Nome do produto"
          :disabled="form.id != null"
          :errors="errors.product_id"
          :options="products"
        />
      </action-dispatcher>
      <!-- <form-group
          slim
          select
          id="type"
          label="Tipo da nota"
          v-model="form.type"
          placeholder="Selecione o tipo da nota ..."
          :options="[
            { id: 'product', name: 'Nota de produto' },
            { id: 'service', name: 'Nota de serviço' }
          ]"
          :errors="errors.type"
        /> -->
      <snow-input
        id="client_id"
        required
        label="Client ID"
        v-model="form.client_id"
        :errors="errors.client_id"
      />
      <snow-input
        id="client_secret"
        required
        label="Client Secret"
        v-model="form.client_secret"
        :errors="errors.client_secret"
      />
      <div class="snow-submit-buttons mt-3">
        <snow-button
          size="lg"
          class="order-lg-1"
          :disabled="!isValid"
          @click="submit"
          text="Salvar"
        />
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="
            visible = false;
            clear();
          "
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import documentValidation from "@/mixins/documentValidation";
import { mapState } from "vuex";
export default {
  mixins: [documentValidation],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    },
    login: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      ...formFields(["type", "client_id", "client_secret"], {
        type: "product",
        client_id: "",
        client_secret: ""
      }),
      loading: false,
      visible: false,
      loginToken: "",
      callback_url: {}
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      } else {
        this.validateCNPJ();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("integration", ["integrationList"]),
    ...mapState("product", ["products"]),
    isValid() {
      return (
        this.form.client_id && this.validDocument && this.form.client_secret
      );
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSubmit() {
      this.loading = false;
      if (!this.integrationToEdit) {
        this.$store
          .dispatch("integration/getBlingHtml", this.loginToken)
          .then(response => {
            if (!response.auth_status) {
              window.open("", "_blank").document.write(response);
              this.visible = false;
              this.$emit("update-list");
            }
          });
      } else {
        this.visible = false;
        this.$emit("update-list");
      }
    },
    submit() {
      this.loading = true;
      let data = { ...this.form };
      let action = this.integrationToEdit
        ? "integration/putIntegration"
        : "integration/postIntegration";
      this.$store
        .dispatch(action, data)
        .then(object => {
          this.$message.success("Integração salva");
          this.loginToken = object.token;
          this.onSubmit();
        })
        .catch(error => {
          this.$message.error("Erro ao salvar integração");
          this.errors = error.response.data;
          this.loading = false;
        })
        .finally(() => {});
    },
    copyUrl(i) {
      navigator.clipboard.writeText(i.url);
      this.$message.success("Url copiada.");
    }
  },
  mounted() {
    this.$store.dispatch("integration/getBlingCallbackUrl").then(response => {
      this.callback_url.url = response.callback_url;
    });
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-bling {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
